var thumbsSwiper = new Swiper('.main-product__swiper-thumbs', {
  loop: false,
  spaceBetween: 4,
  slidesPerView: 3,
  freeMode: true,
  watchSlidesProgress: true,
  breakpoints: {
    1280: { slidesPerView: 8 },
    991: { slidesPerView: 6 },
    520: { slidesPerView: 4 }
  }
});
var mainSwiper = new Swiper('.main-product__swiper-main', {
  loop: true,
  spaceBetween: 0,
  navigation: {
    nextEl: '.main-product__button-next',
    prevEl: '.main-product__button-prev',
  },
  thumbs: {
    swiper: thumbsSwiper,
  },
});